import React, { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUserDetails, UpdateSurvey, getUserSubmitSurvey } from '../../accounts/Overview/OverviewSlice/UserDetailsSlice';

const SurveyModal = () => {
  const [show, setShow] = useState<boolean>(false);
  const [score, setScore] = useState<number | null>(null);
  const [feedback, setFeedback] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const userDetail = useSelector(getAllUserDetails)
  const userSurvey = useSelector(getUserSubmitSurvey)

  const dispatch = useDispatch();

  const handleScoreClick = (val: number) => {
    setScore(val);
    if (val >= 7) {
      setFeedback('');
    };
  };

  const handleSubmit = (score: number | null, feedback: string) => {
    const payload = {
      score: score,
      note: feedback,
      status: 'filled'
    }

    dispatch(UpdateSurvey(payload))
  }


  const handleSubmitAskMeLater = () => {
    const payload = {
      score: 0,
      note: '',
      status: 'ask-later'
    }
    dispatch(UpdateSurvey(payload))
    handleClose();
  }

  const bodyMessage = () => {
    return (
      <div>
        <div className='modal-body'>
          <div className='border-0 mb-4'>
            <h2 className='text-center'>🎉🎉🎉</h2>
            <h2 className='text-center'>Thank you for your awesome survey score!</h2>
          </div>
          <p className='text-gray-800'>
            {`A score of ${score} is a great result and your feedback means the world to us.`}
          </p>
          <p className='text-gray-800'>
            We currently have a great offer of <strong>complimentary $30 worth of credits</strong> for a 5-star review.
          </p>
          <p className='text-gray-800'>
            If you would like to take part, please{' '}
            <a
              href={userDetail?.survey?.survey_link}
              target='_blank'
              rel='noopener noreferrer'
              className='text-primary fw-semibold'
              style={{ cursor: 'pointer' }}
            >
              click here
            </a>.
          </p>
          <div className='border-0 d-flex justify-content-between mt-4'>
            <button className='btn btn-link text-muted px-0 d-flex gap-2' onClick={handleClose}>
              Close
            </button>
            <button
              className='btn btn-primary'
              onClick={() => {
                const link = userDetail?.survey?.survey_link;
                if (link) {
                  window.open(link, '_blank', 'noopener,noreferrer');
                }
              }}
            >
              Get free credit now
            </button>
          </div>
        </div>
      </div>

    )
  }

  const handleClose = () => {
    setShow(false);
    setScore(null);
    setFeedback('');
    setSubmitted(false)
  }

  useEffect(() => {
    if (userDetail?.survey?.status === 'waiting') {
      setShow(true)
    }

    if (userDetail?.survey?.status === 'filled' && userDetail?.survey?.score >= 7) {
      setSubmitted(true)
    }

    if (userDetail?.survey?.status === 'filled' && userDetail?.survey?.score < 7) {
      setShow(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetail?.survey?.status])

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-480px'
      show={show}
    >
      <>
        {!submitted ? (
          <div>
            <div className='modal-body p-16'>
              <div className=' justify-content-center mb-2 mt-6'>
                <h1 className='text-center w-100'>We need your honest feedback!</h1>
              </div>
              <p className='text-center fs-5'>How happy are you with our platform?</p>

              <div className='mt-4'>
                <div className='d-flex flex-wrap justify-content-center gap-2 mb-2'>
                  {[...Array(10)].map((_, i) => {
                    const num = i + 1;
                    const isSelected = score === num;
                    return (
                      <button
                        key={num}
                        type='button'
                        className={`btn ${isSelected ? 'btn-primary text-white' : 'btn-outline-secondary text-gray-800'} rounded px-3 py-2`}
                        onClick={() => handleScoreClick(num)}
                      >
                        {num}
                      </button>
                    );
                  })}
                </div>
                <div className='d-flex justify-content-between gap-2 mb-4'>
                  <p className='text-center fs-5 text-muted'>Not happy at all</p>
                  <p className='text-center fs-5 text-muted'>Extremely happy</p>
                </div>
              </div>

              {score !== null && score < 7 && (
                <div className='mt-2'>
                  <p>
                    <span className='fw-bolder'>Oh no — we’re sorry to hear that! &#128532;</span><br />
                    We’re always looking to improve and make sure your experience is nothing short of excellent.
                  </p>
                  <p className='mb-6'>
                    If you’re open to sharing, please let us know what didn’t quite hit the mark.
                    Your feedback helps us learn and do better next time.
                  </p>
                  <textarea
                    className='form-control'
                    placeholder='Your feedback '
                    rows={3}
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                  />
                </div>
              )}

              <div className={`border-0 d-flex justify-content-between py-4 ${score && score < 7 ? 'mt-4' : 'mt-2'}`}>
                <button className='btn btn-link text-muted px-0 d-flex gap-2' onClick={handleSubmitAskMeLater}>
                  Ask me later
                </button>
                <button
                  className='btn btn-primary d-flex gap-2'
                  disabled={score === null || (score < 7 && feedback.trim() === '')}
                  onClick={() => userSurvey?.isLoading ? null : handleSubmit(score, feedback)}
                >
                  {userSurvey?.isLoading ? (
                    <Spinner />
                  ) : ' Send Feedback'}
                </button>
              </div>
            </div>

          </div>
        ) : (
          <div className='px-4 pt-4'>
            {bodyMessage()}
          </div>
        )}
      </>
    </Modal>
  );
};

export default SurveyModal;
